var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifyingDetailsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7E2C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6292 42.8785H41.246C41.6953 42.8785 42.0596 42.5143 42.0596 42.0649V25.171L37.6596 20.771H23.8605C23.4111 20.771 23.0469 21.1352 23.0469 21.5846V23.7887",
    stroke: "#1E247E",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0469 23.2495V42.066C23.0469 42.5154 23.4111 42.8796 23.8605 42.8796H26.5086",
    stroke: "#1E247E",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0483 40.9767H21.9503C21.5009 40.9767 21.1367 40.6124 21.1367 40.1631V19.6827C21.1367 19.2334 21.5009 18.8691 21.9503 18.8691H39.0315C39.4894 18.8691 39.8606 19.2403 39.8606 19.6978V22.9701",
    stroke: "#1E247E",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6602 20.771V25.1702L42.0601 25.171",
    stroke: "#1E247E",
    strokeWidth: 1.29985,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6914 28.3945H37.4377",
    stroke: "#DA867D",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6914 30.7998H37.4377",
    stroke: "#DA867D",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5117 33.2505H37.4371",
    stroke: "#DA867D",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6914 33.2505H33.5947",
    stroke: "#DA867D",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2746 41.1599C37.2746 38.559 35.1663 36.4507 32.565 36.4507C29.9638 36.4507 27.8555 38.559 27.8555 41.1599C27.8555 43.7608 29.9638 45.8691 32.565 45.8691C35.1663 45.8691 37.2746 43.7608 37.2746 41.1599Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 1.29985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6211 38.9551V41.463",
    stroke: "black",
    strokeWidth: 0.83591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0392 43.1304C33.0392 43.3613 32.852 43.5485 32.6212 43.5485C32.3903 43.5485 32.2031 43.3613 32.2031 43.1304C32.2031 42.8996 32.3903 42.7124 32.6212 42.7124C32.852 42.7124 33.0392 42.8996 33.0392 43.1304Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyingDetailsIcon);
export default __webpack_public_path__ + "static/media/VerifyingDetailsIcon.d6aec19582cb772e38d8cad487cc9228.svg";
export { ForwardRef as ReactComponent };